<div class="file-input-container">
  <input type="file" id="fileInput" (change)="onFileSelected($event)" style="display: none;" #fileInput>
  <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">
    <mat-icon>attach_file</mat-icon> Upload File
  </button>    
  
  <!-- File selected, NOT uploaded yet: pending state -->
  <span *ngIf="selectedFile && !isUploading && !fileUploaded" class="file-label pending-label">
    ⏳ {{ selectedFile.name }} (Pending upload)
  </span>
  
  <!-- File uploaded successfully: success state -->
  <span *ngIf="selectedFile && !isUploading && fileUploaded" class="file-label success-label">
    ✅ {{ selectedFile.name }} (Uploaded)
  </span>
  
  <!-- Uploading: show filename + progress -->
  <div *ngIf="isUploading && selectedFile" class="upload-progress-container">
    <span class="file-label">{{ selectedFile.name }}</span>
    <mat-progress-bar 
      mode="determinate" 
      [value]="uploadProgress"
      class="upload-progress-bar">
    </mat-progress-bar>
    <span class="progress-text">{{ uploadProgress }}%</span>
  </div>
  
  <!-- No file selected -->
  <span *ngIf="!selectedFile" class="file-label">No file uploaded</span>
  
  <button 
    mat-icon-button 
    color="primary" 
    type="button" 
    (click)="onFileLoad()" 
    [disabled]="!selectedFile || isUploading">
    <mat-icon>{{ isUploading ? 'hourglass_empty' : 'send' }}</mat-icon>
  </button>
</div>
